import {useEffect, useState} from 'react'
import {Outlet, useLocation} from 'react-router-dom'
import {HeaderWrapper} from './components/header'
// import {RightToolbar} from '../partials/layout/RightToolbar'
import {ScrollTop} from './components/scroll-top'
import {Content} from './components/content'
import {FooterWrapper} from './components/footer'
import {Sidebar} from './components/sidebar'
// Global RTL sidebar styles
import '../../app/pages/groups/index.scss'
import {
  DrawerMessenger,
  ActivityDrawer,
  InviteUsers,
  UpgradePlan,
  ThemeModeProvider,
} from '../partials'
import {PageDataProvider} from './core'
import {reInitMenu} from '../helpers'
import {ToolbarWrapper} from './components/toolbar'
// import {WhatsAppBubble} from '../../app/components/WhatsAppBubble'
// import {OnboardingWizard} from '../../app/components/OnboardingWizard'
import {SpotlightTutorial} from '../../app/components/SpotlightTutorial/SpotlightTutorial'
import OnboardingGuide from '../../app/components/OnboardingGuide/OnboardingGuide'
import {SupportWidget} from '../../app/components/SupportWidget/SupportWidget'
import MeetingsBubble from '../../app/modules/admin/meetings/MeetingsBubble'
import TasksBubble from '../../app/modules/admin/tasks/TasksBubble'
import {getAdminToken} from '../../app/modules/admin/auth/_requests'
import AffiliateImpersonationBanner from '../../app/components/AffiliateImpersonationBanner'
import SupportChat from '../../app/modules/admin/accounts/SupportChat'
import {PaymentRequiredModal} from '../../app/components/PaymentRequiredModal'
import ProfileGate from '../../app/components/ProfileGate'

// When an admin is impersonating a client (login-as token has admin_switch),
// expose the AI support chat for THIS account inside the client view too.
function useImpersonatedAccountId(): string | null {
  const [id, setId] = useState<string | null>(null)
  useEffect(() => {
    try {
      const raw = localStorage.getItem('kt-auth-react-v')
      const token = raw ? JSON.parse(raw)?.api_token : null
      if (!token) return
      const part = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')
      const payload = JSON.parse(atob(part))
      if (payload?.user?.admin_switch === true) setId(payload.user._id)
    } catch (_) {}
  }, [])
  return id
}

const MasterLayout = () => {
  const location = useLocation()
  const impersonatedAccountId = useImpersonatedAccountId()
  useEffect(() => {
    reInitMenu()
  }, [location.key])

  return (
    <PageDataProvider>
      <ThemeModeProvider>
        <div className='d-flex flex-column flex-root app-root' id='kt_app_root'>
          <div className='app-page flex-column flex-column-fluid' id='kt_app_page'>
            <HeaderWrapper />
            <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
              <Sidebar />
              <div className='app-main flex-column flex-row-fluid' id='kt_app_main'>
                <div className='d-flex flex-column flex-column-fluid'>
                  <ToolbarWrapper />
                  <Content>
                    <Outlet />
                  </Content>
                </div>
                <FooterWrapper />
              </div>
            </div>
          </div>
        </div>

        <AffiliateImpersonationBanner />
        {impersonatedAccountId && <SupportChat accountId={impersonatedAccountId} />}

        {/* begin:: Drawers */}
        <ActivityDrawer />
        {/* <RightToolbar /> */}
        <DrawerMessenger />
        {/* end:: Drawers */}

        {/* begin:: Modals */}
        <InviteUsers />
        <UpgradePlan />
        <PaymentRequiredModal />
        {/* Blocking: require name + phone (e.g. fresh Google sign-up) before using the app */}
        <ProfileGate />
        {/* end:: Modals */}
        <ScrollTop />

        {/* Support Widget */}
        <SupportWidget />

        {/* Onboarding Wizard removed - replaced by SpotlightTutorial */}
        {/* <OnboardingWizard /> */}

        {/* "3 steps to start" guide (campaign → post → Facebook) for new accounts. Replaces the
            post-registration wizard (its cities question moved to the WhatsApp bot) and the
            forced full-length tutorial. */}
        <OnboardingGuide />

        {/* Spotlight Tutorial */}
        <SpotlightTutorial />

        {/* Admin bubbles (meetings + tickets + tasks) - only when admin is logged in */}
        {getAdminToken() && (
          <>
            <MeetingsBubble />
            <TasksBubble />
          </>
        )}
      </ThemeModeProvider>
    </PageDataProvider>
  )
}

export {MasterLayout}
